import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Auth from '@aws-amplify/auth';
import { Link } from 'react-router-dom';
import { AuthScreen } from 'containers';
import * as constants from 'common/constants';
import * as actions from 'actions';

import './index.css';

class ConfirmEmail extends PureComponent {
  state = { error: null };

  resendEmail = async () => {
    let message;
    let hasError = false;

    try {
      await Auth.resendSignUp(this.props.email);
      message = 'Email has been sent.';
    } catch (e) {
      message = 'An error occurred resending the email. Please try again.';
      hasError = true;
    }

    this.props.displayBanner(constants.BANNER_IDS.AUTH, message, hasError);
  };

  render() {
    const { email } = this.props;
    return (
      <AuthScreen
        header={
          <Fragment>
            <h1 className={'text--header'}>COMPLETE SIGN UP</h1>
            <span className={'text---fade'}>
              or <Link to="/">Sign in</Link>
            </span>
          </Fragment>
        }
      >
        <p>
          We just sent an email to{' '}
          <span className={'text--primary'}>{email}</span>. Please check your
          email and follow the instructions to complete the signup.
        </p>
        <p>Didn’t receive your email yet?</p>
        <p>
          Please check your spam folder or{' '}
          <a onClick={this.resendEmail}>resend the email.</a>
        </p>
      </AuthScreen>
    );
  }
}

ConfirmEmail.propTypes = {
  email: PropTypes.string.isRequired,
  displayBanner: PropTypes.func.isRequired,
};

const mapState = ({ auth }) => ({
  email: auth.email,
});
const mapDispatch = {
  displayBanner: actions.banner.display,
  clearError: () => ({ type: constants.LOGIN_FAILED, payload: { error: {} } }),
};

export default connect(
  mapState,
  mapDispatch
)(ConfirmEmail);



// WEBPACK FOOTER //
// ./src/pages/ConfirmEmail/index.js